import { RootState } from '../../Presentation/store';
import { Log, LogPagination, LogSummary } from '../Model/Log';

export const selectLogs = (s: RootState): Log[] =>
  Array.isArray(s.log.list) ? s.log.list : [];

export const selectLogLoading = (s: RootState): boolean => s.log.loading;

export const selectLogPagination = (s: RootState): LogPagination | null => s.log.pagination;

export const selectLogSummary = (s: RootState): LogSummary | null => s.log.summary;

export const selectLogError = (s: RootState): string | undefined => s.log.error;
